
// 数据 state
const state = {
  window: { // 全局尺寸
    width: 0,
    height: 0
  },
  tool: { // 工具尺寸
    width: 0,
    height: 0
  },
  scenes: { // 场景尺寸
    width: 223,
    height: 0
  },
  rightNav: { // 右侧导航尺寸
    width: 0,
    height: 0
  },
  topNav: { // 右侧导航尺寸
    width: 0,
    height: 60
  },
  materialPane: {  //素材面板尺寸
    width: 382,
    height: 0,
  },
  setPanel: {
    width: 260,
    height: 0,
    top: 60,
    right: 0
  },
  timeLine: { // 时间条
    height: 72
  },
  toolScroll: {
    top: 0,
    left: 0
  },
  scollSize: {
    top: 0,
    left: 0.0
  },
  // rightNavComponents: {
  //   hTop: 60,
  //   hSearch: 70,
  //   hOperation: 0, // 搜索栏下方的操作区
  //   hHr: 0, // 水平分割线
  // },
  materialSlideComponents: {
    hTop: 60,
    hSearch: 70,
    hOperation: 0, // 搜索栏下方的操作区
    hHr: 0, // 水平分割线
  }
};

// 获取数据 getters
const getters = {
  scoll_Size: state => state.scollSize,
  Window_Size: state => state.window,
  Tool_Size: state => state.tool,
  // Scenes_Size: state => state.scenes,
  RightNav_Size: state => state.rightNav,
  MaterialPane_Size: state => state.materialPane,
  SetPanel_Size: state => state.setPanel,
  TopNav_Size: state => state.topNav,
  TimeLine_size: state => state.timeLine,
  ToolScroll_Size: state => state.toolScroll,
  RightNavComponents_Size: state => state.rightNavComponents,
  // RightNavTopPartHeight: state => {
  //   const {
  //     hTop,
  //     hSearch,
  //     hOperation,
  //     hHr
  //   } = state.rightNavComponents
  //   return hTop + hSearch + hOperation + hHr;
  // },
};

// 修改数据 mutations
const mutations = {
  save_Window(state, data) {
    // window
    state.window.width = data ? (data.width ? data.width : 0) : 0;
    state.window.height = data ? (data.height ? data.height : 0) : 0;
    // scenes
    state.materialPane.height = state.window.height - state.topNav.height;
    // TopNav
    state.topNav.width = state.window.width;

    state.setPanel.height = state.window.height - state.topNav.height;

    // tool
    state.tool.width = state.window.width - state.materialPane.width - state.setPanel.width;
    state.tool.height = state.window.height - state.topNav.height - state.timeLine.height;
  },
  save_WindowSubtitle (state, data) {
    // window
    state.window.width = data ? (data.width ? data.width : 0) : 0;
    state.window.height = data ? (data.height ? data.height : 0) : 0;
    // scenes
    state.materialPane.height = state.window.height - state.topNav.height;
    // TopNav
    state.topNav.width = state.window.width;

    state.setPanel.height = state.window.height - state.topNav.height;

    // tool
    state.tool.width = state.window.width - state.materialPane.width - state.setPanel.width - 246;
    state.tool.height = state.window.height - state.topNav.height - state.timeLine.height;
  },
  save_SetPanel(state, data) {
    const panelWidth = data ? (data.width ? data.width : 0) : 0;
    state.setPanel.width = Math.max(0, panelWidth);

    state.tool.width = state.window.width - state.materialPane.width - state.setPanel.width;
    state.tool.height = state.window.height - state.topNav.height - state.timeLine.height;
  },
  save_RightNav(state, data) {
    // RightNav
    state.rightNav.width = data ? (data.width ? data.width : 0) : 0;
    state.rightNav.height = state.window.height;
    // TopNav
    state.topNav.width = state.window.width - state.rightNav.width;
    // tool
    state.tool.width = state.window.width - state.scenes.width - state.rightNav.width;
    state.tool.height = state.window.height - state.topNav.height - state.timeLine.height;
  },
  save_Scenes(state, data) {
    // scenes
    state.scenes.width = data ? (data.width ? data.width : 0) : 0;
    state.scenes.height = state.window.height - state.topNav.height;
    // tool
    state.tool.width = state.window.width - state.scenes.width - state.rightNav.width;
    state.tool.height = state.window.height - state.topNav.height - state.timeLine.height;
  },
  save_MaterialPane(state, data) {
    const paneWidth = data ? (data.width ? data.width : 0) : 0;
    state.materialPane.width = Math.max(0, paneWidth);
    const paneHeight = state.window.height - state.topNav.height;
    state.materialPane.height = Math.max(0, paneHeight);
    // tool
    state.tool.width = state.window.width - state.materialPane.width - state.setPanel.width;
    state.tool.height = state.window.height - state.topNav.height - state.timeLine.height;
  },
  save_TimeLine(state, data) {
    // timeLine
    state.timeLine.height = data ? (data.height ? data.height : 0) : 0;
    // tool
    state.tool.width = state.window.width - state.materialPane.width - state.setPanel.width;
    state.tool.height = state.window.height - state.topNav.height - state.timeLine.height;
  },
  save_ToolScroll(state, data) {
    // toolScroll
    state.toolScroll.top = data ? (data.top ? data.top : 0) : 0;
    state.toolScroll.left = data ? (data.left ? data.left : 0) : 0;
  },
  save_scoll(state, data) {
    state.scollSize.top = data.top;
    state.scollSize.left = data.left;
  },
  // save_RightNavComponents(state, data) {
  //   state.rightNavComponents = { ...data };
  // }
}

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/size.js